<template>
  <div class="thirdWrapper" v-if="!isMobile">
    <div class="left" v-for="(item, index) in list.slice(0, 1)" :key="index">
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="left-top"
      >
        <div class="border" v-if="!isIpad"></div>
        <ImageContainer
          v-if="isIpad"
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
          class="img"
        />
        <h1>{{ item.title }}</h1>
        <h2>{{ item.sub_category.name }}</h2>
        <p v-if="!isIpad">{{ item.brief }}</p>
        <h3>
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h3>
        <div class="border" v-if="!isIpad"></div>
      </router-link>
      <div class="left-mid">
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          class="left-mid-content"
          v-for="(item, index) in list.slice(1, 4)"
          :key="index"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <h1>{{ item.title }}</h1>
          <h2>{{ item.sub_category.name }}</h2>
          <p v-if="!isIpad">{{ item.brief }}</p>

          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
        </router-link>
      </div>
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="left-bottom"
        v-for="(item, index) in list.slice(4, 5)"
        :key="index"
      >
        <ImageContainer
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
          class="img"
        />
        <h2>{{ item.sub_category.name }}</h2>
        <h1>{{ item.title }}</h1>
        <p>{{ item.brief }}</p>

        <h3>
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h3>
      </router-link>
    </div>
    <div class="border-mid"></div>
    <div class="right">
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="right-top"
        v-for="(item, index) in list.slice(5, 7)"
        :key="index"
      >
        <ImageContainer
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
          class="img"
        />
        <h1>{{ item.title }}</h1>
        <h2>{{ item.sub_category.name }}</h2>
        <p>{{ item.brief }}</p>

        <h3>
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h3>
      </router-link>
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="right-bottom"
        v-for="(item, index) in list.slice(7, 8)"
        :key="index"
      >
        <ImageContainer
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
          class="img"
        />
        <div class="right-content">
          <h1>{{ item.title }}</h1>
          <h2>{{ item.sub_category.name }}</h2>
          <p>{{ item.brief }}</p>
          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
        </div>
      </router-link>
    </div>
  </div>
  <div class="mobileWrapper" v-if="isMobile">
    <div
      class="mobile-top"
      v-for="(item, index) in list.slice(0, 2)"
      :key="index"
    >
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      >
        <ImageContainer
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
          class="img"
        />
        <div class="mobileContent">
          <h2>{{ item.sub_category.name }}</h2>
          <h1>{{ item.title }}</h1>
          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
        </div>
      </router-link>
    </div>
    <div class="mobile-mid">
      <div
        class="mobile-mid-content"
        v-for="(item, index) in list.slice(2, 6)"
        :key="index"
      >
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <h2>{{ item.sub_category.name }}</h2>
          <h1>{{ item.title }}</h1>
          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
        </router-link>
      </div>
    </div>
    <div class="mobile-bottom">
      <div
        class="mobile-top"
        v-for="(item, index) in list.slice(6, 8)"
        :key="index"
      >
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <div class="mobileContent">
            <h2>{{ item.sub_category.name }}</h2>
            <h1>{{ item.title }}</h1>
            <h3>
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h3>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const isIpad = ref();
    const isMobile = ref();

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 414;
    };

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 414;
      window.addEventListener("resize", handleResize);
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });

    return { isIpad, isMobile, ...useFormatter() };
  },
};
</script>

<style lang="scss" scoped>
.thirdWrapper {
  display: flex;
  justify-content: space-between;
  background: var(--second-bg);
  color: var(--black);
  padding-top: 4.167vw;
  padding-bottom: 4.167vw;
  padding-bottom: 4.167vw;
  overflow: hidden;
  h1 {
    font-size: 1.25vw;
    padding: 0 1.5vw;
    line-height: 1.667vw;
    font-weight: 700;
  }
  p {
    font-size: 0.938vw;
    line-height: 1.25vw;
    font-weight: 500;
    display: block; /* Fallback for non-webkit */
    display: -webkit-box;
    -webkit-line-clamp: 3; /* if you change this, make sure to change the fallback line-height and height */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 3.606vw;
  }
  h2 {
    font-size: 0.833vw;
    line-height: 1.042vw;
    font-weight: 600;
  }
  h3 {
    font-size: 0.833vw;
    line-height: 1.042vw;
    font-weight: 500;
    color: var(--date-grey);
  }
  .left {
    display: grid;
    grid-template-columns: auto;
    .left-top {
      width: 43.333vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-left: 0.781vw;
      grid-gap: 0.521vw;
      cursor: pointer;
      .border {
        width: 43.333vw;
        height: 0.469vw;
        background: var(--black);
      }
    }
    .left-mid {
      display: flex;
      flex-direction: column;
      margin-top: 0;
      grid-gap: 2.083vw;
      position: relative;
      cursor: pointer;
      .left-mid-content {
        width: 43.906vw;
        margin-top: 2.083vw;
        margin-left: 0.781vw;
        display: grid;
        grid-template-areas:
          "mid-image mid-title"
          "mid-image mid-category"
          "mid-image mid-brief"
          "mid-image mid-date";
        grid-template-columns: 18.125vw 24.74vw;
        text-align: left;
        gap: 0.521vw;
        .img {
          width: 18.125vw;
          height: 14.01vw;
          cursor: pointer;
          margin-right: 1.042vw;
          grid-area: mid-image;
        }
        h1 {
          grid-area: mid-title;
          padding: 0;
        }
        h2 {
          grid-area: mid-category;
        }
        p {
          grid-area: mid-brief;
        }
        h3 {
          grid-area: mid-date;
          color: var(--date-grey);
        }
      }
    }
    .left-bottom {
      display: grid;
      grid-template-areas:
        "category"
        "img"
        "title"
        "brief"
        "date";
      width: 41.667vw;
      padding-left: 0.781vw;
      margin-top: 2.083vw;
      text-align: center;
      cursor: pointer;
      .img {
        grid-area: img;
        width: 41.667vw;
        height: 20vw;
        object-fit: cover;
        display: flex;
        align-items: center;
      }
      h2 {
        grid-area: category;
        margin-right: auto;
        margin-bottom: 0.26vw;
      }
      h1 {
        grid-area: title;
        margin-bottom: 0.781vw;
      }
      p {
        grid-area: brief;
        margin-bottom: 0.521vw;
      }
      h3 {
        grid-area: date;
      }
    }
  }
  .border-mid {
    width: 0.052vw;
    height: 106.979vw;
    background: black;
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
    .right-top {
      display: grid;
      grid-template-areas:
        "category"
        "img"
        "title"
        "brief"
        "date";
      width: 41.667vw;
      margin-right: 4.688vw;
      margin-top: 4.688vw;
      text-align: center;
      cursor: pointer;
      .img {
        grid-area: img;
        width: 41.667vw;
        height: 20vw;
        object-fit: cover;
        display: flex;
        align-items: center;
      }
      h2 {
        grid-area: category;
        margin-right: auto;
        margin-bottom: 0.26vw;
      }
      h1 {
        grid-area: title;
        margin-bottom: 0.781vw;
      }
      p {
        grid-area: brief;
        padding: 0 1.5vw;
        margin-bottom: 0.521vw;
      }
      h3 {
        grid-area: date;
      }
    }
    .right-bottom {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 41.667vw;
      height: 22.813vw;
      margin-top: 2.083vw;
      background: var(--black);
      color: var(--light);
      cursor: pointer;
      .img {
        width: 41.667vw;
        opacity: 0.5;
      }
      .right-content {
        position: absolute;
        width: 35.417vw;
        top: 50%;
        transform: translateY(-50%);
        text-align: center;
        grid-gap: 0.781vw;
        pointer-events: none;
        display: grid;
        grid-template-areas:
          "category"
          "title"
          "brief"
          "date";
        h1 {
          grid-area: title;
        }
        h2 {
          grid-area: category;
        }
        h3 {
          grid-area: date;
        }
        p {
          grid-area: brief;
        }
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .thirdWrapper {
    display: flex;
    flex-direction: column;
    h1 {
      font-size: 2.2vw;
      line-height: 2.7vw;
      text-align: left;
      padding: 0;
    }
    h2 {
      font-size: 1.823vw;
      line-height: 2vw;
      font-weight: 600;
    }
    p {
      font-size: 1.693vw;
      line-height: 2.604vw;
      height: 6.766vw;
    }
    h3 {
      font-size: 1.823vw;
      line-height: 2vw;
      font-weight: 300;
      color: var(--black);
    }
    .left {
      display: grid;
      grid-template-areas:
        "leftTop leftbottom"
        "leftmid leftmid";
      .left-top {
        grid-area: leftTop;
        width: 49.349vw;
        display: grid;
        grid-template-areas:
          "top-category top-date"
          "top-title top-title"
          "top-image top-image";
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          right: -2.344vw;
          width: 0.13vw;
          height: 50.781vw;
          background: black;
        }
        .img {
          display: flex;
          align-items: center;
          width: 49.349vw;
          height: 36.979vw;
          grid-area: top-image;
        }
        h1 {
          grid-area: top-title;
        }
        h2 {
          grid-area: top-category;
          text-align: left;
        }
        h3 {
          grid-area: top-date;
          color: var(--black);
          text-align: right;
        }
      }
      .left-mid {
        grid-area: leftmid;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-top: 10.417vw;
        margin-bottom: 14vw;
        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 0.13vw;
          background: black;
          top: -4.167vw;
        }
        .left-mid-content {
          display: grid;
          grid-template-areas:
            "mid-image"
            "mid-category"
            "mid-title"
            "mid-date"
            "mid-brief";
          width: 27.604vw;
          grid-template-columns: none;
          gap: 0.8vw;
          .img {
            width: 27.604vw;
          }
          h1 {
            text-align: left;
          }
          h2 {
            color: var(--black-seven);
          }
          h3 {
            color: var(--black);
          }
        }
      }
      .left-bottom {
        grid-area: leftbottom;
        width: 41.927vw;
        display: grid;
        grid-template-areas:
          "bottom-category bottom-date"
          "bottom-image bottom-image"
          "bottom-title bottom-title"
          "bottom-brief bottom-brief";
        gap: 1vw;
        .img {
          width: 41.927vw;
          grid-area: bottom-image;
        }
        h1 {
          grid-area: bottom-title;
          text-align: left;
        }
        p {
          grid-area: bottom-brief;
          text-align: left;
        }
        h2 {
          grid-area: bottom-category;
        }
        h3 {
          grid-area: bottom-date;
          text-align: right;
        }
      }
    }
    .border-mid {
      display: none;
    }
    .right {
      display: grid;
      grid-template-areas:
        "first second"
        "third third";
      width: 100%;
      margin-top: -10vw;
      .right-top {
        .img {
          display: flex;
          align-items: center;
          width: 49.349vw;
          height: 36.979vw;
          grid-area: right-image;
        }
        h1 {
          grid-area: right-title;
          text-align: left;
          padding: 0;
        }
        h2 {
          grid-area: right-category;
          color: var(--black-seven);
          text-align: left;
        }
        h3 {
          grid-area: right-date;
          text-align: right;
        }
        &:nth-child(1) {
          grid-area: first;
          display: grid;
          width: 49.349vw;
          grid-template-areas:
            "right-category right-date"
            "right-title right-title"
            "right-image right-image";
          grid-gap: 0;
          gap: 0;
          grid-template-rows: 3vw 8.813vw 40.365vw;
          position: relative;
          &::after {
            content: "";
            position: absolute;
            top: 0;
            right: -2.344vw;
            width: 0.13vw;
            height: 50.781vw;
            background: black;
          }
          p {
            display: none;
          }
        }
        &:nth-child(2) {
          grid-area: second;
          width: 41.927vw;
          display: grid;
          grid-template-areas:
            "second-category second-date"
            "second-image second-image"
            "second-title second-title"
            "second-brief second-brief";
          grid-gap: 0;
          // grid-template-rows: 3vw 28.693vw 7vw 20.052vw;
          margin-top: -6vw;
          .img {
            width: 41.927vw;
            grid-area: second-image;
            height: 26.693vw;
          }
          h1 {
            grid-area: second-title;
          }
          p {
            grid-area: second-brief;
            font-size: 1.693vw;
            line-height: 2.344vw;
            font-weight: 400;
            text-align: left;
            margin: 0;
            padding-left: 0;
          }
          h2 {
            grid-area: second-category;
          }
          h3 {
            grid-area: second-date;
            color: var(--black);
          }
        }
      }
      .right-bottom {
        width: 94vw;
        grid-area: third;
        margin-top: 4.036vw;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 7.161vw;
        .img {
          width: 100%;
          object-fit: cover;
        }
        .right-content {
          display: grid;
          grid-template-areas:
            "full-category full-date"
            "full-title full-title";
          width: 70vw;
          h1 {
            grid-area: full-title;
            text-align: center;
            padding: 0;
          }
          h2 {
            grid-area: full-category;
            text-align: left;
            color: var(--light-seven);
          }
          h3 {
            grid-area: full-date;
            text-align: right;
            color: var(--light);
          }
          p {
            display: none;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 414px) {
  .mobileWrapper {
    font-style: normal;
    background: var(--second-bg);
    h1 {
      font-size: 3.2vw;
      line-height: 4vw;
      font-weight: 600;
    }
    h2 {
      font-size: 2.667vw;
      line-height: 3.467vw;
      font-weight: 600;
    }
    h3 {
      font-size: 2.667vw;
      line-height: 3.467vw;
      font-weight: 300;
    }
    .mobile-top {
      max-width: 100vw;
      height: 60.87vw;
      position: relative;
      background: black;
      .img {
        width: 100%;
        height: 60.87vw;
        opacity: 0.5;
      }
      .mobileContent {
        position: absolute;
        width: 68.841vw;
        height: 100%;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        padding-bottom: 2.415vw;
        text-align: center;
        pointer-events: none;
        h1 {
          color: var(--light);
          margin-bottom: 1.449vw;
          font-style: normal;
        }
        h2 {
          font-weight: 600;
          color: var(--light-seven);
          margin-bottom: 0.725vw;
        }
        h3 {
          font-weight: 300;
          color: var(--light-six);
        }
      }
    }
    .mobile-mid {
      display: grid;
      grid-template-areas:
        "mid-first mid-second"
        "mid-third mid-fourth";
      .mobile-mid-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        margin-bottom: 5.333vw;
        .img {
          height: 33.6vw;
          display: flex;
          align-items: center;
          border-right: none;
        }
        h1 {
          color: var(--black);
          margin-bottom: 1.449vw;
          width: 37.923vw;
          margin-left: auto;
          margin-right: auto;
          text-align: center;
          font-style: normal;
          display: block; /* Fallback for non-webkit */
          display: -webkit-box;
          -webkit-line-clamp: 4; /* if you change this, make sure to change the fallback line-height and height */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 4;
          height: 16vw;
        }
        h2 {
          font-weight: 600;
          color: var(--black-seven);
          margin-bottom: 0.725vw;
          margin-top: 1.333vw;
        }
        h3 {
          font-weight: 300;
          color: var(--black-six);
        }
        &:nth-child(1) {
          grid-area: mid-first;
        }
        &:nth-child(2) {
          grid-area: mid-second;
        }
        &:nth-child(3) {
          grid-area: mid-third;
        }
        &:nth-child(4) {
          grid-area: mid-fourth;
        }
      }
    }
    .mobile-bottom {
      padding-bottom: 9vw;
    }
  }
}
</style>